import { type UseControllerProps, useCustomController } from '@faceup/form'
import { FormItem, Scale } from '@faceup/ui'
import type { FormItemType } from '@faceup/utils'
import type { AFFormItem } from '../types'

type ScaleInputProps = UseControllerProps & {
  item: Extract<AFFormItem, { type: FormItemType.Scale }>
}

export const AFScaleFormInput = ({ item, ...props }: ScaleInputProps) => {
  const { formItemProps, inputProps } = useCustomController(props)

  const options = item.options.map(option => {
    return {
      id: option.value,
      label: option.label,
      isActive: (inputProps.value as string | undefined) === option.value,
    }
  })

  return (
    <FormItem {...formItemProps} notClickableLabel>
      <input
        style={{ width: 0, height: 0, visibility: 'hidden', position: 'absolute' }}
        readOnly
        tabIndex={-1}
      />
      <Scale
        startLabel={item.startLabel ?? undefined}
        endLabel={item.endLabel ?? undefined}
        onChange={values => {
          inputProps.onChange(values[0] ?? '')
        }}
        options={options}
      />
    </FormItem>
  )
}
